// extracted by extract-css-chunks-webpack-plugin
module.exports = {"scroll-indicator":"scroll-indicator_E1kiq","scrollDown":"scrollDown_4ybSi"};